// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-container {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 0 1rem;
}

.terms-title {
  font-size: 2rem;
  color: #1a3c6d;
  text-align: center;
  margin-bottom: 2rem;
}

::ng-deep p-table.terms-of-sale-table .p-datatable-table {
  background: aqua;
  border-collapse: collapse;
  width: 100%;
  border: none !important;
}
::ng-deep p-table.terms-of-sale-table .p-datatable-tbody > tr > td {
  padding: 1rem;
  border: none !important;
  vertical-align: top !important;
}
::ng-deep p-table.terms-of-sale-table ul {
  list-style-type: none;
  padding-left: 0;
}
::ng-deep p-table.terms-of-sale-table .flex-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.25rem;
}
::ng-deep p-table.terms-of-sale-table .flex-item .clause-number {
  flex: 0 0 3rem; /* Fixed width for clause number */
  padding-right: 1rem;
}
::ng-deep p-table.terms-of-sale-table .flex-item .clause-text {
  flex: 1;
  margin-left: 1rem; /* Space between number and text */
}
::ng-deep p-table.terms-of-sale-table li strong {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/retail/terms-of-sale/terms-of-sale.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,iBAAA;EACA,eAAA;AACD;;AAEA;EACC,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AACD;;AAGC;EACC,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,uBAAA;AAAF;AAGC;EACC,aAAA;EACA,uBAAA;EACA,8BAAA;AADF;AAIC;EACC,qBAAA;EACA,eAAA;AAFF;AAKC;EACC,aAAA;EACA,uBAAA;EACA,sBAAA;AAHF;AAKE;EACC,cAAA,EAAA,kCAAA;EACA,mBAAA;AAHH;AAME;EACC,OAAA;EACA,iBAAA,EAAA,kCAAA;AAJH;AAQC;EACC,cAAA;AANF","sourcesContent":[".terms-container {\n\tmax-width: 1200px;\n\tmargin: 2rem auto;\n\tpadding: 0 1rem;\n}\n\n.terms-title {\n\tfont-size: 2rem;\n\tcolor: #1a3c6d;\n\ttext-align: center;\n\tmargin-bottom: 2rem;\n}\n\n::ng-deep p-table.terms-of-sale-table {\n\t.p-datatable-table {\n\t\tbackground: aqua;\n\t\tborder-collapse: collapse;\n\t\twidth: 100%;\n\t\tborder: none !important;\n\t}\n\n\t.p-datatable-tbody > tr > td {\n\t\tpadding: 1rem;\n\t\tborder: none !important;\n\t\tvertical-align: top !important;\n\t}\n\n\tul {\n\t\tlist-style-type: none;\n\t\tpadding-left: 0;\n\t}\n\n\t.flex-item {\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\t\tmargin-bottom: 0.25rem;\n\n\t\t.clause-number {\n\t\t\tflex: 0 0 3rem; /* Fixed width for clause number */\n\t\t\tpadding-right: 1rem;\n\t\t}\n\n\t\t.clause-text {\n\t\t\tflex: 1;\n\t\t\tmargin-left: 1rem; /* Space between number and text */\n\t\t}\n\t}\n\n\tli strong {\n\t\tdisplay: block;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
